<app-onb-moldura passo="cardapio" [estado]="estado" [variante]="modo === 'escolher' ? 'pergunta' : 'padrao'"
                 [selo]="modo === 'escolher' ? 'Importação via inteligência artificial' : ''"
                 [titulo]="modo === 'escolher' ? 'Como você quer cadastrar seu cardápio?' : ''"
                 [subtitulo]="modo === 'revisar' ? '' : modo === 'escolher'
                   ? 'Nossa inteligência artificial organiza categorias, adicionais e preços. Você revisa cada detalhe antes de publicar.'
                   : 'Traga o cardápio do jeito mais fácil para você. Tudo pode ser ajustado depois.'">

  <ng-container *ngIf="modo === 'escolher'">
    <section class="pc-caminhos" id="onb-cardapio-portas" [class.pc-caminhos--aberto]="caminhoAberto" aria-label="Como trazer seu cardápio">
      <!-- 01 · foto ou PDF: a área de envio já está no cartão; o que cair aqui segue para o importador da IA -->
      <article class="pc-cartao pc-cartao--principal">
        <div class="pc-topo-principal">
          <span class="pc-recomendado"><i class="fas fa-star" aria-hidden="true"></i> Recomendado · Mais completo</span>
          <span class="pc-aceita"><i class="fas fa-check-circle" aria-hidden="true"></i> Fotos, PDFs e impressos</span>
        </div>
        <div class="pc-cabeca">
          <span class="pc-tile pc-tile--foto"><i class="fas fa-file-alt" aria-hidden="true"></i></span>
          <div>
            <h2>Foto ou PDF do cardápio</h2>
            <p>Tire fotos do cardápio impresso ou anexe o PDF. A IA extrai categorias, produtos, adicionais e preços.</p>
          </div>
        </div>
        <div class="pc-envio" id="onb-cardapio-envio" tabindex="-1" [class.pc-envio--destaque]="envioEmDestaque"
             [class.pc-envio--arrastando]="arrastando" (dragenter)="aoArrastar($event, true)"
             (dragover)="$event.preventDefault()" (dragleave)="aoArrastar($event, false)" (drop)="aoSoltar($event)">
          <span class="pc-envio-ic pc-so-mouse" aria-hidden="true"><i class="fas fa-cloud-upload-alt"></i></span>
          <b class="pc-so-mouse">Arraste suas fotos ou PDF aqui</b>
          <small>JPG, PNG, WebP ou PDF · Pode enviar várias páginas</small>
          <div class="pc-envio-acoes">
            <!-- no toque não existe arrastar: a câmera vem primeiro -->
            <label class="pc-btn pc-btn--pri pc-so-toque">
              <i class="fas fa-camera" aria-hidden="true"></i> Tirar foto do cardápio
              <input type="file" accept="image/*" capture="environment" (change)="aoEscolherArquivos($event)">
            </label>
            <label class="pc-btn pc-btn--pri pc-so-mouse">
              <i class="fas fa-upload" aria-hidden="true"></i> Escolher arquivo
              <input type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.webp" (change)="aoEscolherArquivos($event)">
            </label>
            <label class="pc-btn pc-btn--sec pc-so-toque">
              <i class="fas fa-upload" aria-hidden="true"></i> Escolher foto ou PDF
              <input type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.webp" (change)="aoEscolherArquivos($event)">
            </label>
            <button type="button" class="pc-btn pc-btn--sec" (click)="importeComIa('texto')">
              <i class="fas fa-clipboard" aria-hidden="true"></i> Colar texto
            </button>
            <button type="button" class="pc-btn pc-btn--sec" (click)="importeComIa('planilha')">
              <i class="fas fa-file-csv" aria-hidden="true"></i> Planilha CSV
            </button>
          </div>
        </div>
        <div class="pc-rodape-cartao">
          <span class="pc-rodape-nota"><i class="fas fa-check-circle" aria-hidden="true"></i> Você revisa tudo antes de ir para a loja</span>
          <span>~1 min para ler</span>
        </div>
      </article>

      <div class="pc-coluna">
        <!-- 02 · iFood: o campo do link abre no próprio cartão -->
        <article class="pc-cartao pc-cartao--link" [class.pc-cartao--aberto]="caminhoAberto === 'ifood'"
                 [attr.role]="caminhoAberto === 'ifood' ? null : 'button'" [attr.tabindex]="caminhoAberto === 'ifood' ? null : 0"
                 [attr.aria-expanded]="caminhoAberto === 'ifood'" (click)="abraCaminho('ifood')" (keydown)="teclaNoCartao($event, 'ifood')">
          <button type="button" class="pc-fechar" *ngIf="caminhoAberto === 'ifood'" (click)="fecheCaminho($event)" aria-label="Fechar">
            <i class="fas fa-times" aria-hidden="true"></i>
          </button>
          <span class="pc-chevron" *ngIf="caminhoAberto !== 'ifood'" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
          <div class="pc-cabeca">
            <span class="pc-tile pc-tile--ifood"><img src="/assets/icons/logo-ifood.png" alt="iFood"></span>
            <div>
              <div class="pc-titulo-linha">
                <h2>Trazer do iFood</h2>
                <span class="pc-selo pc-selo--ifood"><i class="fas fa-circle" aria-hidden="true"></i> Mais rápido</span>
              </div>
              <p>Cole o link público da sua loja. Trazemos produtos, fotos, descrições e adicionais.</p>
            </div>
          </div>
          <div class="pc-chips">
            <span class="pc-chip"><i class="fas fa-check" aria-hidden="true"></i> Não precisa de senha</span>
            <span class="pc-chip"><i class="fas fa-images" aria-hidden="true"></i> Traz as fotos</span>
            <span class="pc-chip"><i class="fas fa-layer-group" aria-hidden="true"></i> Traz os adicionais</span>
          </div>
          <div class="pc-rodape-cartao" *ngIf="caminhoAberto !== 'ifood'">
            <span class="pc-acao-link pc-acao-link--ifood">Colar link do iFood <i class="fas fa-arrow-right" aria-hidden="true"></i></span>
            <span>Basta o link da loja</span>
          </div>
          <ng-container *ngIf="caminhoAberto === 'ifood'">
            <ng-container *ngTemplateOutlet="campoDoLink; context: {placeholder: 'https://www.ifood.com.br/delivery/sua-cidade/sua-loja',
              dica: 'Abra sua loja no site do iFood, copie o endereço do navegador e cole aqui.'}"></ng-container>
          </ng-container>
        </article>

        <!-- 03 · outro sistema: mesmo campo; a plataforma é reconhecida pelo link -->
        <article class="pc-cartao pc-cartao--link" [class.pc-cartao--aberto]="caminhoAberto === 'sistema'"
                 [attr.role]="caminhoAberto === 'sistema' ? null : 'button'" [attr.tabindex]="caminhoAberto === 'sistema' ? null : 0"
                 [attr.aria-expanded]="caminhoAberto === 'sistema'" (click)="abraCaminho('sistema')" (keydown)="teclaNoCartao($event, 'sistema')">
          <button type="button" class="pc-fechar" *ngIf="caminhoAberto === 'sistema'" (click)="fecheCaminho($event)" aria-label="Fechar">
            <i class="fas fa-times" aria-hidden="true"></i>
          </button>
          <span class="pc-chevron" *ngIf="caminhoAberto !== 'sistema'" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
          <div class="pc-cabeca">
            <span class="pc-tile pc-tile--sistema"><i class="fas fa-exchange-alt" aria-hidden="true"></i></span>
            <div>
              <div class="pc-titulo-linha">
                <h2>Tenho outro sistema</h2>
                <span class="pc-selo pc-selo--neutro">Pelo link</span>
              </div>
              <p>Cole o link do seu cardápio digital atual e fazemos a migração sem você digitar nada.</p>
            </div>
          </div>
          <div class="pc-plataformas-rot">Compatível com as principais plataformas:</div>
          <div class="pc-plataformas">
            <span class="pc-plataforma" *ngFor="let p of plataformasComLogo">
              <img [src]="p.logo" alt="" [class.pc-logo-escuro]="p.escuro"><span>{{ p.nome }}</span>
            </span>
            <span class="pc-plataforma pc-plataforma--outros" [title]="outrasPlataformas.join(', ')">
              <b>+{{ outrasPlataformas.length }}</b><span>Outros</span>
            </span>
          </div>
          <div class="pc-rodape-cartao" *ngIf="caminhoAberto !== 'sistema'">
            <span class="pc-acao-link pc-acao-link--azul">Migrar de outro sistema <i class="fas fa-arrow-right" aria-hidden="true"></i></span>
            <span>Yooga, Takeat, Brendi e mais</span>
          </div>
          <ng-container *ngIf="caminhoAberto === 'sistema'">
            <ng-container *ngTemplateOutlet="campoDoLink; context: {placeholder: 'Link do seu cardápio digital',
              dica: 'Abra seu cardápio digital, copie o endereço do navegador e cole aqui. Não achou? Use a foto ou o PDF do cardápio.'}"></ng-container>
          </ng-container>
        </article>
      </div>
    </section>

    <!-- ajuda com quem vendeu: o WhatsApp da Mia Gestor que atendeu a loja; o cardápio mandado por lá também chega aqui -->
    <div class="pc-mia">
      <span class="pc-mia-ic" aria-hidden="true"><i class="fab fa-whatsapp"></i></span>
      <div class="pc-mia-tx">
        <div class="pc-mia-titulo">
          <b>Travou em alguma etapa ou prefere ajuda?</b>
          <span class="pc-online" *ngIf="linkWhatsappAjuda && atendimentoAgora"><i aria-hidden="true"></i>Online agora</span>
          <span class="pc-online pc-online--fora" *ngIf="linkWhatsappAjuda && !atendimentoAgora">Respondemos de segunda a sábado, das 9h às 18h</span>
        </div>
        <span *ngIf="telefoneVendedor">Não perca tempo com dúvidas! Nosso time monta o cardápio com você direto no WhatsApp <strong class="pc-numero">{{ telefoneVendedor }}</strong>. Se mandar o cardápio por lá, ele aparece aqui sozinho.</span>
        <span *ngIf="!telefoneVendedor">Não perca tempo com dúvidas! Nosso time pode configurar os produtos ou tirar dúvidas com você.</span>
      </div>
      <a class="pc-btn pc-btn--whats" *ngIf="linkWhatsappAjuda" [href]="linkWhatsappAjuda" target="_blank" rel="noopener"
         (click)="abriuWhatsappAjuda()">
        <i class="fab fa-whatsapp" aria-hidden="true"></i> Pedir ajuda no WhatsApp <i class="fas fa-arrow-right pc-seta" aria-hidden="true"></i>
      </a>
      <button type="button" class="pc-btn pc-btn--whats" *ngIf="!linkWhatsappAjuda"
              (click)="ajuda.emit({passo: 'cardapio', motivo: 'Ajuda para montar o cardápio'})">Pedir ajuda <i class="fas fa-arrow-right pc-seta" aria-hidden="true"></i></button>
    </div>
    <p class="pc-zero">Prefere começar do zero? <button type="button" (click)="cadastreNaMao()">Cadastrar os produtos na mão</button>
      · <a routerLink="/admin/comecar">Fazer depois</a></p>
  </ng-container>

  <!-- campo do link dentro do cartão 02 ou 03 (só um aberto por vez) -->
  <ng-template #campoDoLink let-placeholder="placeholder" let-dica="dica">
    <div class="pc-link" *ngIf="!trazendo">
      <div class="pc-link-campo">
        <input class="onb-inp" [id]="idDoLink" type="url" [(ngModel)]="link" (keyup.enter)="trazerDoLink()" autocomplete="off"
               [placeholder]="placeholder" [attr.aria-label]="caminhoAberto === 'ifood' ? 'Link da sua loja no iFood' : 'Link do seu cardápio no outro sistema'">
        <button type="button" class="pc-btn pc-btn--pri" (click)="trazerDoLink()">Trazer cardápio</button>
      </div>
      <p class="pc-reconhecido" *ngIf="plataformaDoLink"><i class="fas fa-check-circle" aria-hidden="true"></i> Link do {{ plataformaDoLink.nome }} reconhecido</p>
      <p class="pc-dica-link" *ngIf="!plataformaDoLink">{{ dica }}</p>
      <div class="onb-erro" *ngIf="erroDoLink">
        {{ erroDoLink }}
        <button type="button" class="onb-btn onb-btn--link" (click)="importeComIa()">Usar a foto do cardápio</button>
        <button type="button" class="onb-btn onb-btn--link" (click)="ajuda.emit({passo: 'cardapio', motivo: 'Importar pelo link: ' + erroDoLink})">Pedir ajuda</button>
      </div>
    </div>
    <div class="pc-trazendo" *ngIf="trazendo" role="status">
      <b><i class="fas fa-spinner fa-spin"></i> {{ etapaDoLink }}</b>
      <div class="pc-barra" *ngIf="totalDoLink"><span [style.width.%]="progressoDoLink"></span></div>
      <span *ngIf="!totalDoLink">Pode levar um minuto. Não feche esta tela.</span>
      <span *ngIf="totalDoLink">{{ salvosDoLink }} de {{ totalDoLink }} produtos salvos<ng-container *ngIf="falhasDoLink"> · {{ falhasDoLink }} não entraram</ng-container></span>
    </div>
  </ng-template>

  <div class="pc-importador" *ngIf="modo === 'importando'">
    <button type="button" class="onb-btn onb-btn--link pc-voltar" (click)="modo = grupos.length ? 'revisar' : 'escolher'">
      <i class="fas fa-chevron-left"></i> Outras formas de trazer o cardápio
    </button>
    <app-tela-importador-cardapio-ia [embutido]="true" [arquivosIniciais]="arquivosParaIa" [modoInicial]="modoIa"
                                     (onConcluido)="aoImportar($event)"></app-tela-importador-cardapio-ia>
  </div>

  <div class="pc-caixa" *ngIf="modo === 'manual'">
    <button type="button" class="onb-btn onb-btn--link pc-voltar" (click)="volteParaAsPortas()">
      <i class="fas fa-chevron-left"></i> Outras formas de trazer o cardápio
    </button>
    <div class="pc-manual">
      <div class="onb-campo pc-campo--nome">
        <label for="onb-manual-nome">Produto</label>
        <input class="onb-inp" id="onb-manual-nome" [(ngModel)]="manual.nome" placeholder="Ex.: X-Burger" maxlength="120"
               (keyup.enter)="adicioneNaMao()">
      </div>
      <div class="onb-campo">
        <label for="onb-manual-preco">Preço</label>
        <div class="onb-prefixo">
          <span>R$</span>
          <input class="onb-inp" id="onb-manual-preco" [(ngModel)]="manual.preco" inputmode="decimal" placeholder="0,00"
                 (keyup.enter)="adicioneNaMao()">
        </div>
      </div>
      <div class="onb-campo">
        <label for="onb-manual-categoria">Categoria</label>
        <input class="onb-inp" id="onb-manual-categoria" [(ngModel)]="manual.categoria" list="onb-categorias" placeholder="Ex.: Lanches"
               maxlength="80" (keyup.enter)="adicioneNaMao()">
        <datalist id="onb-categorias"><option *ngFor="let c of categorias" [value]="c"></option></datalist>
      </div>
    </div>
    <div class="onb-erro" *ngIf="erroManual">{{ erroManual }}</div>
    <div class="onb-acoes" style="margin-top: 10px">
      <button type="button" class="onb-btn onb-btn--sec" (click)="adicioneNaMao()">
        <i class="fas" [class.fa-plus]="!salvandoManual" [class.fa-spinner]="salvandoManual" [class.fa-spin]="salvandoManual"></i>
        Adicionar produto
      </button>
    </div>
    <ng-container *ngIf="adicionados.length">
      <div class="onb-grupo-rot">Adicionados agora</div>
      <div class="onb-grupo">
        <div class="onb-linha" *ngFor="let a of adicionados">
          <div class="onb-tx"><b>{{ a.nome }}</b></div>
          <span class="pc-valor">R$ {{ a.preco.toFixed(2).replace('.', ',') }}</span>
          <i class="fas fa-check pc-ok"></i>
        </div>
      </div>
    </ng-container>
    <p class="onb-nota">Foto, descrição e adicionais você coloca depois, em Produtos.</p>
  </div>

  <ng-container *ngIf="modo === 'revisar'">
    <div class="onb-erro" *ngIf="erro">{{ erro }} <button type="button" class="onb-btn onb-btn--link" (click)="carregueRevisao()">Tentar de novo</button></div>
    <p class="onb-sub" *ngIf="carregando">Carregando seus produtos…</p>

    <ng-container *ngIf="!carregando && grupos.length">
      <section class="pc-previa" *ngIf="acabouDeImportar && !erro && produtosDaPrevia.length" aria-labelledby="onb-cardapio-previa">
        <div class="pc-previa-topo">
          <h2 id="onb-cardapio-previa" tabindex="-1"><i class="fas fa-check-circle" aria-hidden="true"></i> Seu cardápio já está na loja</h2>
          <ng-container *ngIf="constants.empresa$ | async as empresa">
            <a *ngIf="empresa.linkLoja" class="onb-btn onb-btn--link" [href]="empresa.linkLoja" target="_blank" rel="noopener">
              Ver na loja <i class="fas fa-external-link-alt" aria-hidden="true"></i>
            </a>
          </ng-container>
        </div>
        <div class="pc-previa-produtos">
          <article class="pc-previa-produto" *ngFor="let p of produtosDaPrevia">
            <img *ngIf="p.imagem" [src]="'/images/empresa/' + p.imagem" alt="" loading="lazy">
            <div>
              <h3>{{ p.nome }}</h3>
              <span class="pc-valor" *ngIf="!p.tamanhos">{{ p.preco | currency:'BRL' }}</span>
              <span class="pc-valor" *ngIf="p.tamanhos">Preços por tamanho</span>
            </div>
          </article>
        </div>
      </section>

      <div class="pc-veio-loja" *ngIf="acabouDeImportar && dadosDaLojaDoLink.length" role="status">
        <i class="fas fa-check-circle" aria-hidden="true"></i>
        Trouxemos também {{ textoDadosDaLoja }}. Confira no passo <b>Sua loja</b>: o que você já tinha escolhido ficou como estava.
      </div>

      <div class="onb-erro pc-sem-adicionais" *ngIf="semAdicionais.length" role="status">
        <b>{{ semAdicionais.length === 1 ? '1 produto veio' : semAdicionais.length + ' produtos vieram' }} do iFood sem os adicionais</b>
        (sabores, tamanhos, complementos): {{ semAdicionais.slice(0, 3).join(', ') }}<ng-container *ngIf="semAdicionais.length > 3"> e mais {{ semAdicionais.length - 3 }}</ng-container>.
        Sem eles, o cliente pede sem escolher.
        <a class="onb-btn onb-btn--link" routerLink="/admin/produtos-v2">Completar em Produtos</a>
      </div>

      <p class="onb-sub">
        Você tem <b>{{ produtos.length }} {{ produtos.length === 1 ? 'produto' : 'produtos' }}</b>.
        <span class="onb-pill onb-pill--aviso" *ngIf="semPreco">{{ semPreco }} sem preço</span>
        <span class="onb-pill onb-pill--ok" *ngIf="!semPreco">Todos com preço</span>
      </p>
      <p class="onb-nota" style="margin-top: 2px">Produto sem preço fica escondido da loja até você preencher. O preço salva sozinho ao sair do campo.</p>

      <ng-container *ngFor="let g of grupos">
        <div class="onb-grupo-rot">{{ g.categoria }}</div>
        <div class="onb-grupo">
          <div class="onb-linha pc-produto" *ngFor="let p of g.produtos" [class.pc-produto--falta]="semPrecoNoProduto(p)">
            <div class="onb-tx">
              <b>{{ p.nome }}</b>
              <span *ngIf="p.descricao">{{ p.descricao }}</span>
              <span class="pc-erro" *ngIf="p.erro">{{ p.erro }}</span>
            </div>
            <ng-container *ngIf="!p.tamanhos">
              <div class="onb-prefixo pc-preco">
                <span>R$</span>
                <input class="onb-inp" [id]="'onb-preco-' + p.id" [class.falta]="semPrecoNoProduto(p)" [(ngModel)]="p.precoTexto" inputmode="decimal"
                       placeholder="0,00" [attr.aria-label]="'Preço de ' + p.nome" (blur)="salvePreco(p)" (keyup.enter)="salvePreco(p)">
              </div>
              <span class="pc-estado">
                <i class="fas fa-spinner fa-spin" *ngIf="p.salvando"></i>
                <i class="fas fa-check" *ngIf="p.salvo"></i>
              </span>
            </ng-container>
            <button type="button" class="onb-btn onb-btn--sec" *ngIf="p.tamanhos" (click)="abraEditor(p)">
              Preços por tamanho <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </ng-container>

      <div class="onb-acoes" style="margin-top: 12px">
        <button type="button" class="onb-btn onb-btn--link" (click)="modo = 'escolher'"><i class="fas fa-plus"></i> Trazer mais produtos</button>
        <a class="onb-btn onb-btn--link" routerLink="/admin/produtos-v2">Fotos, adicionais e tamanhos ficam em Produtos</a>
      </div>
    </ng-container>
  </ng-container>

  <!-- antes de escolher um caminho não há o que salvar: a barra só aparece depois -->
  <div class="onb-rodape" *ngIf="modo !== 'importando' && modo !== 'escolher'">
    <span class="onb-dica" *ngIf="modo === 'revisar' && comPreco">{{ comPreco }} {{ comPreco === 1 ? 'produto vai' : 'produtos vão' }} aparecer na loja</span>
    <span class="onb-dica" *ngIf="modo === 'manual' && adicionados.length">{{ adicionados.length }} {{ adicionados.length === 1 ? 'produto vai' : 'produtos vão' }} aparecer na loja</span>
    <span class="onb-dica" *ngIf="(modo !== 'revisar' || !comPreco) && !(modo === 'manual' && adicionados.length)">Precisa de ao menos um produto com preço</span>
    <a class="onb-btn onb-btn--link" routerLink="/admin/comecar">Fazer depois</a>
    <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="conclua()">
      Salvar e continuar
    </button>
  </div>
</app-onb-moldura>
